import { useState } from "react";

const RADIUS_SELECTED = 4;
const RADIUS_UNSELECTED = 7.5;

export function CustomPromsDomainTotalGraphDot(props: any) {
  const [isActive, setIsActive] = useState(false);

  const {
    cy,
    cx,
    color,
    onDotClick,
    payload,
    selectedId,
    onMouseOver,
    onMouseOut,
  } = props;

  if (cy === null && cy === null) return null;

  const isSelected = isActive || payload?.id === selectedId;

  const handleEnter = () => {
    setIsActive(true);
    onMouseOver?.();
  };

  const handleLeave = () => {
    setIsActive(false);
    onMouseOut?.();
  };

  const handleClick = () => {
    onDotClick?.({ ...payload, cx, cy });
  };

  return (
    <circle
      cx={cx}
      cy={cy}
      r={isSelected ? RADIUS_SELECTED : RADIUS_UNSELECTED}
      fill={color}
      stroke={isSelected ? color : undefined}
      strokeOpacity={isSelected ? 0.38 : undefined}
      strokeWidth={8}
      style={{
        cursor: "pointer",
        zIndex: isSelected ? "4000 !important" : undefined,
      }}
      onClick={handleClick}
      onTouchStart={handleClick}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    />
  );
}
